import * as AppConstants from 'app/AppConstants';
import {selectIsPublic} from 'state/environment/environmentSelectors';
import {selectCardById} from 'state/card/cardSelectors';
import {CARD_SETTINGS} from 'app/CardConstants';
import {parseQuerystring} from 'utilities/URL';
const QUERY_KEY = 'enable';

const settingsLoaded = settings => ({
  type: AppConstants.CARD__SETTINGS_LOADED,
  payload: {settings},
});

const loadSettingsFromCard = cardId => (dispatch, getState) => {
  const card = selectCardById(getState(), cardId);
  const embed = (card && card.embed) || {};
  const settings = [
    embed.summary && CARD_SETTINGS.SUMMARY,
    embed.drill && CARD_SETTINGS.DRILL,
    embed.table && CARD_SETTINGS.TABLE,
    embed.title && CARD_SETTINGS.TITLE,
    embed.picker && CARD_SETTINGS.CHART_PICKER,
    embed.dataExport && CARD_SETTINGS.EXPORT,
    embed.filter && CARD_SETTINGS.FILTER,
  ].filter(Boolean);

  return dispatch(settingsLoaded(settings));
};

const loadSettingsFromUrl = () => dispatch => {
  const query = parseQuerystring();
  const param = query[QUERY_KEY] || '';
  const settings = param.split(',').filter(Boolean);
  dispatch(settingsLoaded(settings));
};

export const loadCardSettings = cardId => (dispatch, getState) => {
  const state = getState();
  const isPublic = selectIsPublic(state);
  const loadFn = isPublic ? loadSettingsFromCard : loadSettingsFromUrl;
  return dispatch(loadFn(cardId));
};
